import { useLazyQuery } from '@apollo/client/react/hooks';
import { Device } from '@oolio-group/domain';
import { useEffect } from 'react';
import { GET_DEVICES } from '../../graphql/devices';
import { sessionSubject } from '../../state/sessionObservable';
import { setSession } from '../../state/preferences';

export const useDevices = () => {
  const [refetch, { data, loading, error }] = useLazyQuery<{
    devices: Device[];
  }>(GET_DEVICES, {
    fetchPolicy: 'no-cache',
    onCompleted: data => {
      const session = sessionSubject.getValue();
      if (data?.devices && session?.device?.id) {
        const updatedDevice = data.devices.find(
          d => d.id === session.device?.id,
        );
        if (updatedDevice) {
          const updatedSession = { ...session, device: updatedDevice };
          sessionSubject.next(updatedSession);
          setSession(updatedSession);
        }
      }
    },
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    devices: data?.devices,
    loading,
    error,
    refetch,
  };
};
